import { teal } from '@mui/material/colors';
import Grid from '@mui/material/Grid';
import React from 'react';
import AboutSelect from '../../components/About/AboutSelect';
import TermsText from '../../components/About/Texts/Terms';
import Footer from '../../components/General/Footer';
import HeaderCard from '../../components/General/HeaderCard';
import Head from '../../components/Header/Head';
import Header from '../../components/Header/Header';
import withApollo from '../../lib/withApollo';

const TermsPage = () => {
  const title = 'Terms of Service';
  return (
    <>
      <Header subheader={title} active="terms" />
      <Head title={`${title}`} />
      <AboutSelect selection={5} />
      <Grid
        container
        spacing={0}
        alignItems="center"
        justifyContent="center"
        className="pt-4 pb-4"
      >
        <Grid item lg={7} md={8} sm={11} xs={12}>
          <HeaderCard
            title={title}
            background={teal[600]}
            content={<TermsText />}
          />
        </Grid>
      </Grid>
      <Footer />
    </>
  );
};

export default withApollo(TermsPage);
